<div
  ngbDropdown
  [autoClose]="true"
  placement="bottom-center"
  class="d-inline-block"
  autoClose="outside"
  *ngIf="currentUser && showNotificationIcon"
  class="user-notification-container user-info-container"
>
  <div
    id="currentUserDropdownToggle"
    class="user-notification"
    ngbDropdownToggle
    (click)="onClick()"
  >
    <div class="bell-icon-container">
      <ng-container *ngIf="notificationCount > 0; else newNotification">
        <img src="/assets/images/icons/top-bar/bell-active.svg" />
      </ng-container>
      <ng-template #newNotification>
        <img src="/assets/images/icons/top-bar/bell.svg" />
      </ng-template>
    </div>
    <div class="badgeCount">
      <span class="notificationCount">{{ notificationCount || 0 }}</span>
    </div>
  </div>
  <div
    ngbDropdownMenu
    aria-labelledby="currentUserDropdownToggle"
    class="user-notification-dropdown"
  >
    <div class="dropdown-header">
      <span class="heading">Notifications</span>
      <button
        (click)="onDeleteAll(true)"
        class="deleteAllButton btn btn-complete"
      >
        Delete All
      </button>
      <button (click)="markAsRead(true, undefined, undefined)" class="readAllButton btn btn-complete">
        Mark All As Read
      </button>
    </div>
    <div class="dropdown-body-container"  #dropdownBodyContainer>
      <div
        class="dropdown-body"
        *ngFor="let notification of notifications"
        (click)="markAsRead(false, notification.notificationId, notification.isRead)"
      >
        <ng-container *ngIf="notification.isActive">
          <div
            class="notification"
            [ngClass]="{ highlight: !notification.isRead }"
          >
            <div class="notification-text">
              {{ notification.description }}
            </div>
            <div class="notification-time">
              <span class="time">{{
                notification.lastModifiedAt | wafShortDate
              }}</span>
            </div>
            <div class="archive">
              <button
                class="btn delete-button link"
                #deleteNotification
                (click)="onDelete($event, false, notification);$event.target.disabled = true"
              ></button>
            </div>
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="isEndOfNotifications">
        <div class="endOfNotifications">
          <span>End of Notifications</span>
        </div>
      </ng-container>
    </div>
  </div>
</div>
